module.exports = __webpack_public_path__ + "img/wild_table.9150bdf6.png";